export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const upperWord = (str: string): string => {
  return str[0].toUpperCase() + str.slice(1);
};

export const formatFrequency = (t: any, value: string | null): string => {
  if (!value) return '--';

  const mapping: Record<string, string> = {
    one_off_price: t('once'),
    week_price: t('weekly'),
    two_week_price: t('every2Weeks'),
    three_week_price: t('every3Weeks'),
    four_week_price: t('every4Weeks'),
  };

  return mapping[value] || value;
};
